import React from "react";
import { Helmet } from "react-helmet";
import { graphql } from 'gatsby';
import { changeLocale } from "gatsby-plugin-intl";
import { getBrowserLanguage } from "../utils/getBrowserLanguage";
import { OtherTranslations } from "../hooks/queries/OtherTranslations";
import { Layout } from '../layouts/Main';
import { WelcomeSellBox } from "../components";

import { getCurrentCountryCode } from '../utils/getCurrentCountryCode';

import { Header, Footer, BoxSection, AdditionalResourcesBlock } from '../components';

const IndexPage = (props) => {
    const country_code = getCurrentCountryCode();
    const data = props.data;
    const translation_data = OtherTranslations();
    const t = translation_data.mb.otherTranslation.localizations.find(item => item.locale === props.pageContext.language) || translation_data.mb.otherTranslation;

    if (typeof window !== 'undefined') {
        const browser_language = getBrowserLanguage();
        console.log(`Browser Language: ${browser_language}`);
        if ((window.location.pathname === "/" || window.location.pathname === '/support-center/') && browser_language !== "en") {
            changeLocale(browser_language, `/${country_code}/`);
        }
    }

    return (
        <Layout>
            <Helmet htmlAttributes={{ lang: `${props.pageContext.language}` }}>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1, minimum-scale=1" />
                <title>FreeConferenceCall.com | Support Center</title>
                <meta name="description" content="The FreeConferenceCall.com support center has everything you need to know about conferencing tips and tricks, customer success stories, corporate events and more. Check it out here." />
                <meta content="website" property="og:type" />
                <meta content={`https://www.freeconferencecall.com${props.uri}`} property="og:url" />
                <meta content="https://www.freeconferencecall.com/images/fcc_logo_fb.png" property="og:image" />
                <meta content="The FreeConferenceCall.com support center has everything you need to know about conferencing tips and tricks, customer success stories, corporate events and more. Check it out here." property="og:description" />
                <meta content="FreeConferenceCall.com | Support Center" property="og:title" />
                <meta content="FreeConferenceCall.com" property="og:site_name" />
                <meta content="freeconferencecall" property="fb:admins" />
                {
                    (props.uri !== '/' && props.uri !== '/support-center') && <link rel="canonical" href={`https://www.freeconferencecall.com/support-center/${props.pageContext.language}`} />
                }
                
                <body className="home" />
            </Helmet>
            <Header intl={props.pageContext.intl} categories={data.mb.categories}></Header>
            <WelcomeSellBox country_code={country_code} />

            <BoxSection data={data.mb} type="featured_topics" t={t} country_code={country_code} />
            <BoxSection data={data.mb} type="browse_resources" t={t} country_code={country_code} />
            <AdditionalResourcesBlock data={data.mb} t={t} country_code={country_code} />

            <Footer></Footer>
        </Layout>);
}

export default IndexPage;

export const pageQuery = graphql`
query IndexQuery($date: String, $language: String!) {
    mb {
        categories: categories(where: {in_browse_resources: true}, sort:"index:asc"){
            id
            Name
            link
            external_link
            tag
            index
            locale
            icon {
                url
            }
            localizations(where: {locale: $language}) {
                id
                Name
                link
                external_link
                tag
                index
                locale
                icon {
                    url
                }
            }
            subcategories {
                id
                description
                name
                link
                tag
                index
                locale
                localizations(where: {locale: $language}) {
                    id
                    description
                    name
                    link
                    tag
                    index
                    locale
                }
            }
        }
        browse_resources: categories(limit:6, where: {in_browse_resources: true}, sort: "index:asc")  {
            id
            link
            external_link
            Name
            description
            icon {
                url
            }
            index
            locale
            localizations(where: {locale: $language}) {
                id
                link
                external_link
                Name
                description
                icon {
                    url
                }
                index
                locale
            }
        }
        featured: blogposts(limit:3, where: {featured_topic: true, publish_date_lte: $date, status: "published"}, sort: "publish_date:desc")  {
            id
            title
            sub_title
            locale
            excerpt
            created_at
            publish_date
            locale
            categories{
                id
                Name
                link
                external_link
                tag_color
                locale
                localizations(where: {locale: $language}) {
                    id
                    Name
                    link
                    external_link
                    tag
                    tag_color
                    locale
                }
            }
            content
            slug
            localizations(where: {locale: $language}) {
                id
                title
                sub_title
                locale
                excerpt
                created_at
                publish_date
                locale
                categories{
                    id
                    Name
                    link
                    external_link
                    tag
                    locale
                }
                content
                slug
            }
        }
        additional_resources: additionalResources(sort: "sort_index:asc") {
            id
            title
            link
            external_link
            sort_index
            locale
            localizations(where: {locale: $language}) {
                id
                title
                link
                external_link
                sort_index
                locale
            }
        }
    }
}
`;
